import '../../app.es6';
import angular from 'angular';

class CourseDetailController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member');
    }
    if (!this.$sessionStorage[this.Const.SSAPP_COURSE_ID]) {
      this.$location.path('/staff');
    }

    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }

    // 前画面で表示されるコース一覧を取得
    this.courseList = this.$sessionStorage[this.Const.SSAPP_COURSE_LIST];
    // 現在表示されている生徒一覧が、取得したコース一覧の何番目のものかを判別する
    this.currentIdx = this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX];
    // 一番最後のコースを選択した場合、'>'を隠すために取得
    this.courseListLength = this.courseList.length - 1;
    if (this.currentIdx === this.courseListLength) {
      this.maxFlg = true;
    } else {
      this.maxFlg = false;
    }
    // APIからのデータ取得が完了したか判定する
    this.getDataFin = false;

    // 表示する校名/クラス名
    this.displaySchoolName = this.courseList[this.currentIdx].schoolName;
    this.displayCourseName = this.courseList[this.currentIdx].courseName;

    // 表示する生徒の一覧
    this.memberList = [];
    // APIから取得した生徒が存在している場合：true
    // APIから取得した生徒が存在していない場合：false
    this.existenceFlg = true;

    // 選択したコースのID
    let currentCourseId = this.$sessionStorage[this.Const.SSAPP_COURSE_ID];
    let getCoursesCourseIdMembersParams = {
      courseId: currentCourseId
    };
    this.getCoursesCourseIdMembers(getCoursesCourseIdMembersParams);

    Page.setTitle(this.Const.TITLE.memberList);

    CourseDetailController.$inject = [
      '$scope', '$sessionStorage', '$location',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  getCoursesCourseIdMembers (params) {
    this.commonFactory.overlayShow();
    this.commonApiFactory.getCoursesCourseIdMembers(params)
    .then((result) => {
      return new Promise((resolve) => {
        if (result.length === 0) {
          this.existenceFlg = false;
          return resolve();
        }
        result.forEach((d) => {
          let memberObj = {
            id: d.id,
            name: d.name,
            gender: d.gender,
            imagePath: ''
          };
          let imgPath;
          switch (d.gender) {
            case this.Const.GENDER_TYPE.male:
              imgPath = 'res/st_top/common_icon_user_male.png';
              break;
            case this.Const.GENDER_TYPE.female:
              imgPath = 'res/st_top/common_icon_user_female.png';
              break;
            default:
              imgPath = 'res/st_top/common_icon_user_default.png';
          }
          memberObj.imagePath = imgPath;
          this.memberList.push(memberObj);
        });
        this.existenceFlg = true;
        return resolve();
      });
    })
    .then(() => {
      this.getDataFin = true;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.error('error : ', error);
      this.existenceFlg = false;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  toMemberDetail (obj) {
    // 遷移元がゲスト動画、sessionにvideoIdを持っている場合動画移動処理実施
    if (this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] === this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo &&
    this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]) {
      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] = obj.id;
      this.$location.path('/staff/guest_video');
    } else {
      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = obj.id;
      this.$sessionStorage[this.Const.SSAPP_USER_NAME] = obj.name;
      this.$sessionStorage[this.Const.SSAPP_GENDER] = obj.gender;
      this.$location.path('/staff/member_detail');
    }
  }

  // 現在選択されているコースより、
  // 前画面で一つ下に表示されていたコースの生徒一覧を表示する
  toNextCourseDetail () {
    this.getDataFin = false;
    // 表示されている生徒一覧をクリア
    this.memberList = [];
    this.currentIdx = this.currentIdx + 1;
    this.setCourseDetail();
  }

  // 現在選択されているコースより、
  // 前画面で一つ上に表示されていたコースの生徒一覧を表示する
  toBeforeCourseDetail () {
    this.getDataFin = false;
    // '>'を表示させる
    this.maxFlg = false;
    // 表示されている生徒一覧をクリア
    this.memberList = [];
    this.currentIdx = this.currentIdx - 1;
    this.setCourseDetail();
  }

  setCourseDetail () {
    let currentCourse = this.courseList[this.currentIdx];
    let currentCourseId = currentCourse.courseId;
    let currentSchoolName = currentCourse.schoolName;
    let currentCourseName = currentCourse.courseName;
    if (this.currentIdx === this.courseListLength) {
      this.maxFlg = true;
    } else {
      this.maxFlg = false;
    }
    this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX] = this.currentIdx;
    this.$sessionStorage[this.Const.SSAPP_COURSE_ID] = currentCourseId;
    this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = currentSchoolName;
    // 表示する校名/クラス名
    this.displaySchoolName = currentSchoolName;
    this.displayCourseName = currentCourseName;
    let getCoursesCourseIdMembersParams = {
      courseId: currentCourseId
    };
    this.getCoursesCourseIdMembers(getCoursesCourseIdMembersParams);
  }
}

angular.module('myApp').controller('CourseDetailController', CourseDetailController);



// WEBPACK FOOTER //
// ./app/components/course-detail/course-detail-controller.es6